import { store } from "app/store"
import { setLoading } from "app/loadingSlice"
import { logout } from "app/userSlice"

let BASE_URL = ""

if (process.env.NODE_ENV === "development") {
  //BASE_URL = "https://main-pflanzmich.testingserver3.qubidu.com"
}

// Types based on the Go EmployeeStats2JSON structure
export interface EmployeeStats2Data {
  id: number
  email: string
  firstName: string
  lastName: string
  adduration: number
  fdtickets: number
  fdactions: number
  fdemails: number
  fdchats: number
  fdnotes: number
  fdokratings: number
  fdbadratings: number
  fdgoodratings: number
  fdworked: number
  fdresolved: number
  fdclosed: number
  fcassigned: number
  fcresolved: number
  fcuniqueResolved: number
  fcmessages: number
  fcresponses: number
  fcaverageRating: number
}

export interface EmployeeStats2Response {
  response: {
    success: boolean
    results: any
  }
  stats: EmployeeStats2Data[]
}

export const fetchEmployeeStats2 = async (
  token: string,
  from: string,
  to: string
): Promise<EmployeeStats2Response | undefined> => {
  if (!token) {
    store.dispatch(logout())
    return undefined
  }

  store.dispatch(setLoading(true))

  try {
    const url = BASE_URL + "/employee/stats2?from=" + encodeURIComponent(from) + "&to=" + encodeURIComponent(to)

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
    })

    store.dispatch(setLoading(false))

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    return data as EmployeeStats2Response
  } catch (error) {
    store.dispatch(setLoading(false))
    console.error("Error fetching employee stats 2:", error)
    throw error
  }
}

// Alternative version that uses the current user's token from the store
export const fetchEmployeeStats2WithStoredToken = async (
  from: string,
  to: string
): Promise<EmployeeStats2Response | undefined> => {
  const token = store.getState().userState.token
  return fetchEmployeeStats2(token, from, to)
}
